const Base64Url = require('./Base64Url')
const JWTConfig = require('./JWTConfig')
const createHmac = require('create-hmac')

module.exports = {
    parseToken : function (token) {
        const totalParts = 3        
        const tokenParts = token.split('.')
        let isValidToken = false
        let headersDecoded, payloadDecoded = null

        if(count(tokenParts) === totalParts) {
            const headers = tokenParts[0];
            const payload = tokenParts[1];
            const signature = tokenParts[2];
            
            const headersDecoded = JSON.parse(Base64Url.decode(headers))
            const payloadDecoded = JSON.parse(Base64Url.decode(payload))

            if(headersDecoded && payloadDecoded)
            {
                const secretKey = JWTConfig.SECRET_TOKEN;
                const data = "{"+headers+"}.{"+payload+"}";
                var hmac = createHmac('sha256', Buffer.from(secretKey))
                hmac.update(data)
                
                const clientSignature = Base64Url.encode(hmac.digest())
               
                isValidToken = clientSignature === signature;
            }

            return isValidToken ? {
                headers : headersDecoded,
                payload : $payloadDecoded
             } : false
        }
    }
}